<template>
  <div>
    <div>
      <el-form :inline="true" :model="searchFormData">
        <el-form-item>
          <el-input v-model="searchFormData.name" placeholder="输入名称搜索"></el-input>
        </el-form-item>
        <el-form-item label="项目选择">
          <el-select
              @change="selectProject"
              v-model="searchFormData.project_id" placeholder="全部"
                clearable
                filterable
                style="width:100%"
              >
              <el-option
                v-for="item in projectDataList"
                :key="item.project_id"
                :label="item.name"
                :value="item.project_id"
              />
          </el-select>
        </el-form-item>

        <el-form-item label="职位选择">
          <el-select
              v-model="searchFormData.job_id" placeholder="全部"
                clearable
                filterable
                style="width:100%"
              >
              <el-option
                v-for="item in jobDataList"
                :key="item.job_id"
                :label="item.title"
                :value="item.job_id"
              />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="abc">
      <div class="abc_left">
        <span>面试状态</span>
        <el-radio-group v-model="searchFormData.status" @change="changeStatus">
          <el-radio label="">全部</el-radio>
          <el-radio :label="0">已报名</el-radio>
          <el-radio :label="1">已通过</el-radio>
          <el-radio :label="2">淘汰</el-radio>
          <el-radio :label="3" >备选</el-radio>
        </el-radio-group>
      </div>
      <div class="abc_right">

        <!--
        <el-button type="text" v-if="!batchStatus"  @click="batch">批量操作</el-button>

        <el-button type="text" @click="completes" v-if="batchStatus" style=" font-size: 14px; margin-right:20px;">完成</el-button>
        <el-checkbox v-if="batchStatus" style="margin-right: 20px;" @change="batchSelect">
          全选
        </el-checkbox>
        <el-button type="text" v-if="batchStatus" style=" font-size: 14px; margin-right: 20px;" @click="batchInvite">邀请</el-button>
-->

      </div>
    </div>

    <div class="middle">
      <EnrollItem  v-for="(item,index) in pageProps.records" 
        :key="index" 
        :obj="item" 
        :type="1"
        :batch="batchStatus"
        @inviteInterview="inviteInterview(item)"
        @pass="operate(item.enroll_id ,1)"
        @out="operate(item.enroll_id,2)"
        @alternative="operate(item.enroll_id,3)"

        @doselect="item.checked=!item.checked"
      >
        <!--<div slot="box">
          <el-button type="primary"  v-show="!batchStatus">去聊呗</el-button>
          <el-checkbox v-model="item.checked" :value="item.enroll_id"   v-show="batchStatus"></el-checkbox>
        </div>-->
        
      </EnrollItem>


   </div>

     <!--分页-->
    <div class="bottom">
      <div>
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" 
        :total="pageProps.total" :page-size="pageProps.pageSize" 
        :current-page="pageProps.pageNum" 
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange" />
      </div>
   </div>
   <invite-dialog ref="inviteDialog" @refresh="refreshData" ></invite-dialog>

</div>
</template>

<script>
import inviteDialog from "@/components/job/invite-dialog.vue";
import EnrollItem from '@/views/director/work/recruit/components/enroll-item.vue'
import { operateEnroll,getEnroll} from "@/api/director/enroll/index";//recruitList,

import { projectList} from "@/api/director/project/index.js";
import { jobList} from "@/api/director/job/index.js";


export default {
  components: {
    EnrollItem,inviteDialog
  },


  
  data () {
    return {
      
      // 全选
      isIndeterminate: true,

      allstetus:false,

      pageProps: {
        records: [],
        total: 0,
        pageNum: 1,
        pageSize: 6,
      },

      searchFormData: {
        type:1,//1报名审核，2地址审核，3签写合同，4结算评价
        name: "",
        project_id: "",
        job_id:"",
        status: "", //0待邀，1通过，2淘汰，3备选
        page: 0,
        limit: 0,
      },

      selectIds:[],

      projectDataList:[],
      jobDataList:[],

      batchStatus:false,
    }
  },

  mounted () {
    this.initProjectList();
   // this.initJobList();
    this.fetchData();
  },


  methods: {

    selectProject(e){
      this.searchFormData.project_id=e;
      this.searchFormData.job_id=""
      this.initJobList();
    },
    search(){
      this.fetchData();
    },

    changeStatus(){
      this.fetchData();
    },

    refreshData(){
      this.fetchData();

    },
    
     //邀请
     inviteInterview(item){

      //user_app_id,job_id,enroll_id
      var that=this;
      console.log(item);
      this.$refs.inviteDialog.init(item.user_app_id,item.job_id,item.enroll_id);

    },
    
    batchInvite(){
      var that=this;
      var enroll_ids=[];
      for (let item of that.pageProps.records) {
          if(item.checked==true){
            enroll_ids.push(item.enroll_id);
          }
      }
      if(enroll_ids.length<=0){
        this.$message.error("请选择数据");
        return;
      }
      this.$refs.inviteDialog.init(enroll_ids);

    },



    operate(enroll_id,status){
      var that=this;
      var params={
        enroll_id:enroll_id,
        status:status//1邀请2淘汰3备选
      }

      operateEnroll(params).then((response) => {
        console.log(response);
        if(response.code==200){
          that.$message.success("操作成功");

          that.refreshData() ;         
        }else{
             that.$message.error(response.msg?response.msg:"操作失败");


        }
      });
    },

  




    fetchData () {
      var that = this;
      that.searchFormData.page = that.pageProps.pageNum;
      that.searchFormData.limit = that.pageProps.pageSize;

      getEnroll(that.searchFormData).then((response) => {
        console.log(response);
        var datas=response.data.data;
        for (let item of datas) {
          item.checked = false;
        }

        that.pageProps.records = datas;
        that.pageProps.total = response.data.total;
      });
    },



    //项目列表
    initProjectList(){
      var that = this;
      projectList({}).then((response) => {
        console.log('projectList',response);
        that.projectDataList = response.data;
      });
      
    },
    

    //职位列表
    initJobList(){
      var that = this;
      jobList({ project_id:this.searchFormData.project_id}).then((response) => {
        console.log('jobList',response);
        that.jobDataList = response.data;
      });
      
    },
    

    // 当前页变更
    handleCurrentChange (num) {
      this.pageProps.pageNum = num;
      this.fetchData();
    },

    // 每页显示页面数变更
    handleSizeChange (size) {
      this.pageProps.pageSize = size;
      this.fetchData();
    },

    batch(){
      this.batchStatus=true
    },
    completes(){
      this.batchStatus=false
    },

    batchSelect(e){
      console.log(e);
        for (let item of this.pageProps.records) {
          item.checked = e;
        }
    },

   
   
  }
};
</script>

<style lang="scss" scoped>
.abc {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #999999;
  font-size: 14px;
  .abc_left {
    span {
      margin-right: 20px;
    }
  }
}
.middle {
  margin: 10px auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  min-height: 400px;
  
}
.bottom {
  width: 300px;
  margin-left: 336px;
}
</style>